
var product_on_page = $('.products-on-page');
var next_url = product_on_page.data('next-url');
var loadmore_button = $('.load-more-button-btn');
var loading_spinner = $('.loading-spinner');
var TARGET_VISIBLE_PRODUCTS = 32;
var currentVisibleLimit = TARGET_VISIBLE_PRODUCTS;

function limitVisibleProducts(limit) {
    // Get all visible product items (not including those already marked as hidden-overflow)
    let allProducts = product_on_page.find('.grid__item');
    let visibleProducts = allProducts.filter(':visible').not('.hidden-overflow');
    
    // If we have more visible products than the limit, hide the excess
    if (visibleProducts.length > limit) {
        visibleProducts.slice(limit).addClass('hidden-overflow').hide();
    }
}

function loadMore() {       
    loading_spinner.show();
    loadmore_button.hide();

    if (next_url) {
        $.ajax({
            url: next_url,
            type: 'GET',
            dataType: 'html',
            beforeSend: function() {
                loading_spinner.show();
                loadmore_button.hide();
            },
            success: function(data) {
                loading_spinner.hide();
                loadmore_button.show();
                let new_products = $(data).find('.products-on-page').html();
                next_url = $(data).find('.products-on-page').data('next-url');
                
                // Get current visible count before adding new products
                let currentVisible = product_on_page.find('.grid__item:visible').not('.hidden-overflow').length;
                
                // Remove previously hidden overflow products to include them in the new batch
                product_on_page.find('.grid__item.hidden-overflow').removeClass('hidden-overflow').show();
                
                if(next_url) {
                    loadmore_button.show();
                } else {
                    loadmore_button.hide();
                }
                product_on_page.append(new_products);
                
                // Re-init product card sliders for newly appended items
                try {
                    if (typeof window.initCardProductSliders === 'function') {
                        window.initCardProductSliders();    
                    }
                    
                    if (typeof yotpoWidgetsContainer !== 'undefined' && yotpoWidgetsContainer.initWidgets) {
                        yotpoWidgetsContainer.initWidgets();
                    }
                        
                } catch (e) {
                    console.warn('initCardProductSliders failed', e);
                }
                
                // Increase the visible limit by 32 for the new batch
                currentVisibleLimit = currentVisible + TARGET_VISIBLE_PRODUCTS;
                
                // Limit visible products after your filtering logic runs
                setTimeout(function() {
                    if (!next_url) {
                        // No more pages - show all remaining hidden products
                        product_on_page.find('.grid__item.hidden-overflow').removeClass('hidden-overflow').show();
                    } else {
                        limitVisibleProducts(currentVisibleLimit);
                    }
                }, 100);
                
            },
            error: function(xhr, status, error) {
                loading_spinner.hide();
                loadmore_button.show();
                console.error(error);
            }
        });
    } else {
        loadmore_button.hide();
    }
}

// Apply limit on initial page load
$(document).ready(function() {
    // Wait for initial filtering logic to complete, then limit to 32 products
    setTimeout(function() {
        limitVisibleProducts(TARGET_VISIBLE_PRODUCTS);
    }, 200);
});

